// Settlement Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../../actions';

// functions
import * as Functions from '../../../functions/common';
import { SettlementState, SettlementUnloadState } from '../../states/SettlementState';
import { SettlementResume } from '../../../models/Entities/SettlementResume/SettlementResume';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';



type KnownAction = 
| Actions.SettlementsResume.SettlementResume_GetAll_Request_Action
| Actions.SettlementsResume.SettlementResume_GetAll_Receive_Action
| Actions.SettlementsResume.SettlementResume_GetAll_Fail_Action


export const SettlementResumeReducer: Reducer<SettlementState> = (
    state: SettlementState | undefined, incomingAction: Action): SettlementState => {
    
        if (state === undefined) {
            return SettlementUnloadState as SettlementState;
        }
    
        const action = incomingAction as KnownAction;

        var CurrentSettlement: Settlement | undefined = undefined;

        switch (action.type) {
            case 'SETTLEMENTRESUME_GETALL_REQUEST_ACTION':
                return {
                    ...state,
                    
                };
            case 'SETTLEMENTRESUME_GETALL_RECEIVE_ACTION':
                return {
                    ...state,
                   
                };
            case 'SETTLEMENTRESUME_GETALL_FAIL_ACTION':
                return {
                    ...state,
                    
                };
            
            default:
                return state;
        }
    }
